import React, { useState, useEffect } from 'react'
import { Table, IconButton, Icon, Panel, ButtonGroup, Row, Col, Input } from 'rsuite'
import { useHistory } from 'react-router-dom'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { budgetFormat } from '../../utils/formatterUtil'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import { getManageUserRoleSearchName } from '../../redux/actions/manageAccess'
import { doneLoading, startLoading } from '../../utils/loading'

export default function SearchForNamesTable({
  schema,
  loading,
  // onSelect = () => {},
  // onSearch = () => {},
  // onCancel = () => {},
  // onClick = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const history = useHistory()
  const [tableData, setTableData] = useState([])
  const [txtFirstNameVal, SetTxtFirstNameVal] = useState('')
  const [txtLastNameVal, setTxtLastNameVal] = useState('')

  const [displayLength, setDisplayLength] = useState(10)
  const [page, setPage] = useState(1)
  const [totalSize, setTotalSize] = useState(0)
  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 10, label: 10 },
    { value: 20, label: 20 },
    { value: 40, label: 40 },
  ]

  useEffect(() => {
    setTableData(schema?.data?.values || [])
    setTotalSize(schema?.data?.totalSize)
  }, [schema])

  const handleSearch = () => {
    // console.log('handleSearch ')
    var req = {
      fullName: txtFirstNameVal,
      lastName: txtLastNameVal,
    }
    console.log('req==>', req)
    // onSearch(req)
    handleSearchManageMasterData(displayLength, 1, txtFirstNameVal, txtLastNameVal)
    setPage(1)
  }

  const handleCancel = () => {
    SetTxtFirstNameVal('')
    setTxtLastNameVal('')
    handleSearchManageMasterData(displayLength, 1, null, null)
    setPage(1)
  }

  const handleChangeLength = (dataKey) => {
    console.log('handleChangeLength dataKey', dataKey)
    setPage(1)
    setDisplayLength(dataKey)
    handleSearchManageMasterData(dataKey, 1, txtFirstNameVal, txtLastNameVal)
  }

  const handleChangePage = (dataKey) => {
    console.log('handleChangePage 111 page', dataKey)

    setPage(dataKey)
    handleSearchManageMasterData(displayLength, dataKey, txtFirstNameVal, txtLastNameVal)
  }

  const handleSearchManageMasterData = async (pageSize, pageNumber, firstName, lastName) => {
    startLoading()
    try {
      const response = await getManageUserRoleSearchName(firstName, lastName, pageSize, pageNumber)

      if (response) {
        setTableData(response?.data?.values || [])
        setTotalSize(response?.data?.totalSize || 0)
      }
    } catch (e) {
      console.log('e', e)
    }
    doneLoading()
  }
  
  return (
    <>
      {schema?.searchForm && (
        <Panel bordered header={'ค้นหา'} collapsible defaultExpanded>
          <div style={{ marginTop: -10, marginBottom: -10 }}>
            <Row style={{ marginBottom: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24}></Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                {schema.searchForm.firstName.label}
                <Input
                  value={txtFirstNameVal}
                  onChange={(value) => {
                    SetTxtFirstNameVal(value)
                  }}
                />
              </Col>

              <Col lg={8} md={8} sm={24} xs={24}>
                {schema.searchForm.lastName.label}
                <Input
                  value={txtLastNameVal}
                  onChange={(value) => {
                    setTxtLastNameVal(value)
                  }}
                />
              </Col>
              <Col lg={4} md={4} sm={24} xs={24}></Col>
            </Row>

            <Row style={{ marginBottom: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24}></Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <SearchButton disabled={false} onClick={handleSearch}>
                  ค้นหา
                </SearchButton>
                {`  `}
                <CancelButton disabled={false} onClick={handleCancel}>
                  ยกเลิก
                </CancelButton>
              </Col>
            </Row>
          </div>
        </Panel>
      )}

      <Table
        wordWrap
        // height={350}
        // autoHeight={tableData.length < 10}
        minHeight={350}
        autoHeight
        loading={loading}
        data={tableData}
        style={{ marginTop: 10 }}
      >
        <Column width={90} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>

        <Column minWidth={250} flexGrow={1}>
          <HeaderCell>ชื่อ - สกุล</HeaderCell>
          <Cell dataKey="fullName" />
        </Column>
        <Column width={300}>
          <HeaderCell>หัวหน้าหน่วยจัดการ</HeaderCell>
          <Cell dataKey="leaderManage" />
        </Column>
        <Column width={300}>
          <HeaderCell>สนับสนุนวิชาการ (พี่เลี้ยง) </HeaderCell>
          <Cell dataKey="coordinatorSuportor" />
        </Column>
      </Table>

      <TablePagination
        lengthMenu={defaultLengthMenu}
        activePage={page}
        renderLengthMenu={(lengthMenu) => {
          return (
            <>
              {lengthMenu}
              {`รายการ/หน้า`}
            </>
          )
        }}
        renderTotal={(total) => {
          return <>{` ทั้งหมด ${total} รายการ`}</>
        }}
        displayLength={displayLength || 5}
        total={totalSize}
        onChangePage={handleChangePage}
        onChangeLength={handleChangeLength}
      />
    </>
  )
}
